var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinDoorKnock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51543 3.94954C1.92433 5.64764 0.927722 8.12129 0.96642 10.448C1.04723 15.3102 3.23886 17.1508 6.74368 23.8426C8.00618 26.7873 9.32385 29.9032 10.5771 35.0637C10.7512 35.8249 10.9211 36.532 10.9997 36.5933C11.0782 36.6546 11.2481 35.945 11.4223 35.1838C12.6755 30.0232 13.9932 26.9099 15.2557 23.9652C18.7605 17.2733 20.9521 15.4327 21.0329 10.5705C21.0716 8.24379 20.0725 5.76766 18.4814 4.06956C16.6639 2.12977 13.9224 0.694173 10.9997 0.634142C8.07693 0.574072 5.333 2.00974 3.51543 3.94954Z",
    fill: "#D15214",
    stroke: "#66280A",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 14.4675C13.1198 14.4675 14.8385 12.7489 14.8385 10.6288C14.8385 8.50867 13.1198 6.79001 10.9997 6.79001C8.87959 6.79001 7.16089 8.50867 7.16089 10.6288C7.16089 12.7489 8.87959 14.4675 10.9997 14.4675Z",
    fill: "#66280A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinDoorKnock);
export default __webpack_public_path__ + "static/media/maps-pin-DoorKnock.39847214d51928e20f7099a636ef8c32.svg";
export { ForwardRef as ReactComponent };